import { useGetPaginatedCustomersQuery } from '../impl/blfApi/endpoints/customers';

export const useCustomers = () => {
  const { data, isLoading, isFetching } = useGetPaginatedCustomersQuery();

  return {
    customers: data?.items,
    isCustomersLoading: isLoading || isFetching,
  };
};
